import * as Colours from './colours';

// From the Design System Typography:
// https://github.com/EurostarDigital/design-system/blob/master/workspaces/ds/packages/ds-core/src/typography/fonts.ts
const fontFiles = {
  ABCSocialBold: 'ABCSocial-Bold.woff2',
  ABCSocialRegular: 'ABCSocial-Regular.woff2',
  // LaPontaiseBlack: 'LaPontaise-Black.woff2', Currently not in styleguide but likely to be in future
  LaPontaiseRegular: 'LaPontaise-Regular.woff2',
  LaPontaiseSemiBold: 'LaPontaise-SemiBold.woff2'
};

// Pulling font files from /files because https://static.eurostar.com/shared/fonts/ had CORS issues
const imports = `
  @font-face {
    font-family: 'ABC Social';
    font-display: swap;
    font-weight: bold;
    src: url('/fonts/${fontFiles.ABCSocialBold}') format('woff2');
  }

  @font-face {
    font-family: 'ABC Social';
    font-display: swap;
    font-weight: normal;
    src: url('/fonts/${fontFiles.ABCSocialRegular}') format('woff2');
  }

  @font-face {
    font-family: 'La Pontaise Regular';
    font-display: swap;
    src: url('/fonts/${fontFiles.LaPontaiseRegular}') format('woff2');
  }

  @font-face {
    font-family: 'La Pontaise Semi Bold';
    font-display: swap;
    src: url('/fonts/${fontFiles.LaPontaiseSemiBold}') format('woff2');
  }
`;

const breakpoints = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200
};

// From the Design System Typography
// https://github.com/EurostarDigital/design-system/blob/master/workspaces/ds/packages/ds-core/src/typography/fonts.ts
const ABCSocial = "'ABC Social', 'Arial', 'sans-serif'";
const LaPontaiseSemiBold = "'La Pontaise Semi Bold', 'Arial', 'sans-serif'";
const LaPontaiseBlack = "'La Pontaise Black', 'Arial', 'sans-serif'";

const fontFamily = {
  ABCSocial,
  LaPontaiseSemiBold,
  LaPontaiseBlack
};

// Functional Heading fonts

const functionalHeading = `
  font-family: ${ABCSocial};
  font-weight: bold;
  color: ${Colours.Core.CoreNavy};
  text-align: left;
  margin-top: 0;
  margin-bottom: 1rem;
  -webkit-font-smoothing: antialiased;
`;

const FunctionalHeadingXL = `
  ${functionalHeading}
  font-size: 2rem;
  line-height: 2.5rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 3.125rem;
    line-height: 3.5rem;
    margin-bottom: 1.5rem;
  }
`;

const FunctionalHeadingL = `
  ${functionalHeading}
  font-size: 1.75rem;
  line-height: 2rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 2.375rem;
    line-height: 2.5rem;
    margin-bottom: 1.5rem;
  }
`;

const FunctionalHeadingM = `
  ${functionalHeading}
  font-size: 1.5rem;
  line-height: 2rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 1.75rem;
  }
`;

const FunctionalHeadingS = `
  ${functionalHeading}
  font-size: 1.25rem;
  line-height: 1.5rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 1.375rem;
  }
`;

const FunctionalHeadingXS = `
  ${functionalHeading}
  font-size: 1.125rem;
  line-height: 1.5rem;
  margin-bottom: 0.5rem;
`;

// Brand Semi fonts

const brandSemi = `
  font-family: ${LaPontaiseSemiBold};
  font-weight: normal;
  color: ${Colours.Core.CoreNavy};
  text-align: left;
  margin-top: 0;
  margin-bottom: 1rem;
  -webkit-font-smoothing: antialiased;
`;

const BrandSemiHeadingXL = `
  ${brandSemi}
  font-size: 2rem;
  line-height: 2.5rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 3rem;
    line-height: 3.5rem;
    margin-bottom: 1.5rem;
  }
`;

const BrandSemiHeadingL = `
  ${brandSemi}
  font-size: 1.75rem;
  line-height: 2rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 2.25rem;
    line-height: 2.5rem;
    margin-bottom: 1.5rem;
  }
`;

const BrandSemiHeadingM = `
  ${brandSemi}
  font-size: 1.5rem;
  line-height: 2rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 1.75rem;
  }
`;

const BrandSemiHeadingS = `
  ${brandSemi}
  font-size: 1.25rem;
  line-height: 1.5rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 1.375rem;
  }
`;

const BrandSemiHeadingXS = `
  ${brandSemi}
  font-size: 1.125rem;
  line-height: 1.5rem;
  margin-bottom: 0.5rem;
`;

const BrandSemiHeadingXXS = `
  ${brandSemi}
  font-size: 0.875rem;
  line-height: 1.5rem;
  margin-bottom: 0.5rem;
`;

// Brand Black fonts - Currently not in styleguide but likely to be in future

const brandBlack = `
  font-family: ${LaPontaiseBlack};
  font-weight: normal;
  color: ${Colours.Core.CoreNavy};
  text-align: left;
  margin-top: 0;
  margin-bottom: 1rem;
  -webkit-font-smoothing: antialiased;
`;

const BrandBlackHeadingXL = `
  ${brandBlack}
  font-size: 2rem;
  line-height: 2.5rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 3rem;
    line-height: 3.5rem;
    margin-bottom: 1.5rem;
  }
`;

const BrandBlackHeadingL = `
  ${brandBlack}
  font-size: 1.75rem;
  line-height: 2rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 2.25rem;
    line-height: 2.5rem;
    margin-bottom: 1.5rem;
  }
`;

const BrandBlackHeadingM = `
  ${brandBlack}
  font-size: 1.5rem;
  line-height: 2rem;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 1.75rem;
  }
`;

const BrandBlackHeadingS = `
  ${brandBlack}
  font-size: 1.375rem;
  line-height: 1.5rem;
`;

const BrandBlackHeadingXS = `
  ${brandBlack}
  font-size: 1.125rem;
  line-height: 1.5rem;
  margin-bottom: 0.5rem;
`;

// Body fonts

const bodyBase = `
  color: ${Colours.Greyscale.Charcoal};
  text-align: left;
  margin-top: 0;
  margin-bottom: 1rem;
  -webkit-font-smoothing: antialiased;
`;

const body = `
  ${bodyBase}
  font-family: ${ABCSocial};
  font-weight: normal;
`;

const bodyBold = `
  ${bodyBase}
  font-family: ${ABCSocial};
  font-weight: bold;
`;

const BodyXL = `
  ${body}
  font-size: 1.125rem;
  line-height: 1.5rem;
`;

const BodyXLBold = `
  ${bodyBold}
  font-size: 1.125rem;
  line-height: 1.5rem;
`;

const BodyL = `
  ${body}
  font-size: 1rem;
  line-height: 1.5rem;
`;

const BodyLLink = `
  ${body}
  font-size: 1rem;
  line-height: 1.5rem;
  text-decoration: underline;
  text-decoration-color: ${Colours.Greyscale.Charcoal};
  &:hover {
    text-decoration: none;
  }
`;

const BodyLBold = `
  ${bodyBold}
  font-size: 1rem;
  line-height: 1.5rem;
`;

const BodyM = `
  ${body}
  font-size: 0.875rem;
  line-height: 1.5rem;
`;

const BodyMBold = `
  ${bodyBold}
  font-size: 0.875rem;
  line-height: 1.5rem;
`;

const BodyMCollapsed = `
  ${body}
  font-size: 0.875rem;
  line-height: 1rem;
  margin-bottom: 0.5rem;
`;

const BodyMCollapsedBold = `
  ${bodyBold}
  font-size: 0.875rem;
  line-height: 1rem;
  margin-bottom: 0.5rem;
`;

const BodyS = `
  ${body}
  font-size: 0.75rem;
  line-height: 1rem;
  margin-bottom: 0.5rem;
`;

const BodySBold = `
  ${bodyBold}
  font-size: 0.75rem;
  line-height: 1rem;
  margin-bottom: 0.5rem;
`;

const BodyXS = `
  ${body}
  font-size: 0.625rem;
  line-height: 1rem;
  margin-bottom: 0.5rem;
`;

const BodyXSBold = `
  ${bodyBold}
  font-size: 0.625rem;
  line-height: 1rem;
  margin-bottom: 0.5rem;
`;

const fonts = {
  imports,
  fontFamily,
  FunctionalHeadingXL,
  FunctionalHeadingL,
  FunctionalHeadingM,
  FunctionalHeadingS,
  FunctionalHeadingXS,
  BrandSemiHeadingXL,
  BrandSemiHeadingL,
  BrandSemiHeadingM,
  BrandSemiHeadingS,
  BrandSemiHeadingXS,
  BrandSemiHeadingXXS,
  BrandBlackHeadingXL,
  BrandBlackHeadingL,
  BrandBlackHeadingM,
  BrandBlackHeadingS,
  BrandBlackHeadingXS,
  BodyXL,
  BodyXLBold,
  BodyL,
  BodyLLink,
  BodyLBold,
  BodyM,
  BodyMBold,
  BodyMCollapsed,
  BodyMCollapsedBold,
  BodyS,
  BodySBold,
  BodyXS,
  BodyXSBold
};

export default fonts;
